import { useState, useEffect } from 'react';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _SSTPeriod } from '../../../core/services/dataBean/EntityCatalogVdos';
interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}
export const SelectPeriodoPhva = ({ idSelector, onChange, label }: Props) => {

    const _sst = useDataBean(_SSTPeriod);


    const [lista, setLista] = useState([]);
    const [id, setID] = useState(0);

    useEffect(() => {

        setID(idSelector);
        getLista();

    }, [])
    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
    }

    const getLista = () => {
        _sst.instance.getSSTPeriodCatalogPorPropiedades({ State: 100 }, null).then(
            (resp: any) => {
                setLista(resp);
            }
        );
    }

    return (
        <>
            <label>{label ?? "Periodo"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={0}>...</option>
                {lista &&
                    lista.map((item: any) => {
                        return (
                            <>
                                <option key={item.DataBeanProperties.IDSSTPeriod} value={item.DataBeanProperties.IDSSTPeriod} >{item.DataBeanProperties.Year}</option>
                            </>)
                    })
                }
            </select>
        </>
    )
}